export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5743.d5c909d5.jpg";